import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useId } from '../contexts/id'

export default function QueryParamHandler() {
  const queryParams = Object.fromEntries(
    new URLSearchParams(useLocation().search).entries()
  )
  const { setSessionId, setBoardId } = useId()
  useEffect(() => {
    if (!!queryParams.boardId && !!queryParams.sessionId) {
      setSessionId(queryParams.sessionId)
      localStorage.setItem('sessionId', queryParams.sessionId)
      setBoardId(queryParams.boardId)
      localStorage.setItem('boardId', queryParams.boardId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams.boardId, queryParams.sessionId])
  return null
}
